import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import sessionManager from '../api/SessionManager';

const ProtectedRoute = ({ component: Component, children, isAuthenticated, ...rest }) => {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isAuth, setIsAuth] = useState(isAuthenticated);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Double-check token validity with sessionManager
        const isValid = sessionManager.isUserAuthenticated();
        //console.log("Protected route auth check:", isValid);
        setIsAuth(isValid);
      } catch (error) {
        console.error("Auth check error:", error);
        setIsAuth(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkAuth();
  }, []);

  if (isChecking) {
    // Show loading spinner while checking auth
    return <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
    </div>;
  }

  if (!isAuth) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If children are provided, render them
  if (children) {
    return children;
  }
  
  // Otherwise render the component prop
  return Component ? <Component {...rest} /> : null;
};

export default ProtectedRoute;
